// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useLocales } from "react-localized"
import { ContextMenuContainer, useContextMenu } from "../lib"
import { PurchaseOrder, PurchaseOrderProductDTO } from "../models"
import { OrderProductEditComponent } from "./OrderProductEditComponent"


const OrderProductEditorAppendContextPanel: React.FC<{order: PurchaseOrder}> = ({
  order
}) => {
  const {gettext} = useLocales()
  const panelCtx = useContextMenu()
  return (
    <ContextMenuContainer
      close={() => panelCtx.close()}
      isOpen={true}
      title={gettext("Order product")}
    >
      <OrderProductEditComponent
        currency={order.getCurrency()}
        onUpdate={(dto: PurchaseOrderProductDTO) => {
          order.addLine(dto)
        }}
      />
    </ContextMenuContainer>
  )
}

export {OrderProductEditorAppendContextPanel}